<template>
    <div class="PersonageInfo">
        <el-row class='PersonageInfo-topImg mt-50' :gutter="40">
            <el-col  :span="24" class="text-left mt-20">
                <p class="text-left1"><span class="pl-40" v-html="personInfo.doc_content"></span></p>
            </el-col>
            <!-- <el-col :span="7" class="person">
                <img class="image" :src="personInfo.img_url" alt="">
            </el-col> -->
        </el-row>
        <div style="height: 50px"></div>
    </div>
</template>
<script>
import {
    getDocBaseInfoByIdApi,
} from "@/api"
export default {
    name: 'personage-info-wrapper',
    data () {
        return {
            list: [1, 2, 3],
            personId:'',
            personInfo: {}
        }
    },
    created(){
        this.personId = this.$route.query.personId
        this.getPersonInfo({ doc_id: this.personId })
    },
    methods: {
        async getPersonInfo(param){
            const { data } = await getDocBaseInfoByIdApi(param)
            this.personInfo = data.docBase
        },
    }
}
</script>
<style lang="scss" scoped>
  @import './XPersonInfo.scss';
</style>
